import cn from "classnames";
import { SeaSearchCardModel } from "entities/SeaSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { Container } from "./Container";
import styles from "./ContainerList.module.scss";

import { useOpenedCardContainers } from "../../model/hooks/openedCardContainers.hook";

type ContainersProps = {
  className?: string;
  data: Nullable<SeaSearchCardModel>;
};

export const ContainerList: RFC<ContainersProps> = ({ data, className }) => {
  const containers = useOpenedCardContainers(data);

  const hasContainers = containers.length > 0;

  return (
    <div className={cn(styles.containerList, className)}>
      {hasContainers && containers.map((container) => <Container key={container.number} container={container} />)}
    </div>
  );
};
